import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    TemplateRef,
    ViewChild,
    inject,
} from '@angular/core';
import { Router } from '@angular/router';
import {
    NgbActiveModal,
    NgbModalModule
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-calendar-details',
    templateUrl: './calendar-details.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, NgbModalModule],
})
export class CalendarDetailsComponent {
    @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
    activeModal = inject(NgbActiveModal);
    @Input() data: any;
    modalData;

    isAuthenticated: boolean = false;

    constructor(
        public router: Router
    ) {}

    ngOnInit() {
        this.modalData = this.data;
        this.isAuthenticated = localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    onSubmit(data) {
        // onSubmit(link) {
        // window.open(link, '_blank');

        let id = data?.event?.id;
        if (this.isAuthenticated) {
            this.router.navigate(['/cgc-developmental-programme/registration'], {
                queryParams: { calendarEventId: id }
            });
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: `/cgc-developmental-programme/registration?calendarEventId=${id}`,
                },
            });
        }
        this.activeModal.dismiss();
    }
}
